import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	letter-spacing: 0.3px;
	display: flex;
	flex-direction: column;
	border-radius: 1px;
	padding: 16px;
	color: ${colors.grey8};
`;

export const Row = styled.div`
	display: flex;
	align-items: center;

	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	height: 24px;
	margin-bottom: 4px;
`;

export const Color = styled.div`
	background: ${({ color }) => color};
	width: 8px;
	height: 8px;
	border-radius: 100%;
	margin-right: 9px;
`;

export const Title = styled.div`
	margin-right: 9px;
`;

export const Range = styled.div`
	color: ${colors.green1};
	font-size: 13px;
	font-weight: normal;
	min-width: 85px;
    margin-right: 9px;
}
`;

export const Value = styled.div`
	margin-left: auto;
`;
